exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shared-bestfriend-component{padding-top:58px;padding-bottom:48px;margin-top:8px;color:#f8f8f8;background-color:#172660}.shared-bestfriend-component__fb-chat-button{-webkit-box-shadow:0 0 64px 16px rgba(0,0,0,.15);-moz-box-shadow:0 0 64px 16px rgba(0,0,0,.15);box-shadow:0 0 64px 16px rgba(0,0,0,.15)}.shared-bestfriend-component__fb-chat-button>img{height:32px;padding-bottom:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/shared/bestfriend.scss
// module id = 1030
// module chunks = 0